import script from "./ArticleView.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleView.vue?vue&type=script&setup=true&lang=js"

import "./ArticleView.vue?vue&type=style&index=0&id=71f2259e&scoped=true&lang=css"

import exportComponent from "C:\\fukunocha\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f2259e"]])

export default __exports__